"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toDayAvailabilities = void 0;
const toDayAvailabilities = (weeklyAvailableTimes) => {
    return {
        // 下手にループ回すより、こっちの方がシンプルかな
        mon: weeklyAvailableTimes.mon.available,
        tue: weeklyAvailableTimes.tue.available,
        wed: weeklyAvailableTimes.wed.available,
        thu: weeklyAvailableTimes.thu.available,
        fri: weeklyAvailableTimes.fri.available,
        sat: weeklyAvailableTimes.sat.available,
        sun: weeklyAvailableTimes.sun.available,
        hol: weeklyAvailableTimes.hol.available
    };
};
exports.toDayAvailabilities = toDayAvailabilities;
//# sourceMappingURL=toDayAvailabilities.js.map